import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propArrayStr, propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../../../../helpers/use/useHook';
import AccountBillingInformationAdminBox from './AccountBillingInformationAdminBox';
import AccountBillingInformationBillingBox from './AccountBillingInformationBillingBox';
const AccountBillingInformation = (props) => {
    const { accountMember, enableDomains, onSubmitAdmin, onSubmitBillingInformation, } = props;
    const { boolState: isShowAdminForm, changeFalse: hideAdminForm, changeTrue: showAdminForm, } = useBoolState(false);
    const { boolState: isShowBillingForm, changeFalse: hideBillingForm, changeTrue: showBillingForm, } = useBoolState(false);
    const showAdminBox = useCallback(() => {
        showAdminForm();
        hideBillingForm();
    }, [showAdminForm, hideBillingForm]);
    const showBillingBox = useCallback(() => {
        showBillingForm();
        hideAdminForm();
    }, [showBillingForm, hideAdminForm]);
    return (_jsxs("div", Object.assign({ className: 'mypage_content_section billing_information_section billing_description' }, { children: [_jsx("h2", Object.assign({ className: 'mypage_content_section_title' }, { children: "\u8ACB\u6C42\u66F8\u9001\u4ED8\u5148" })), _jsxs("div", Object.assign({ className: 'mypage_content_section_billing_body' }, { children: [_jsx(AccountBillingInformationAdminBox, { accountMember: accountMember, enableDomains: enableDomains, hideForm: hideAdminForm, isShow: isShowAdminForm, onSubmit: onSubmitAdmin, showForm: showAdminBox }), _jsx(AccountBillingInformationBillingBox, { accountMember: accountMember, enableDomains: enableDomains, hideForm: hideBillingForm, isShow: isShowBillingForm, onSubmit: onSubmitBillingInformation, showForm: showBillingBox })] }))] })));
};
AccountBillingInformation.propTypes = {
    accountMember: propShape().isRequired,
    enableDomains: propArrayStr().isRequired,
    onSubmitAdmin: propFunc().isRequired,
    onSubmitBillingInformation: propFunc().isRequired,
};
export default AccountBillingInformation;
